import { LOCK_IT_IN_CABIN_TYPES, LOCK_IT_IN_FLOW_CABIN_TYPES } from '@/ducks/programs/lockItInRate/constants';

/**
 * @see https://virginvoyages.atlassian.net/browse/MSH-104810
 * @see https://virginvoyages.atlassian.net/browse/MSH-128120?focusedCommentId=1074630
 */
export const isLockItInFlowCabin = (cabinType = '') => LOCK_IT_IN_FLOW_CABIN_TYPES.includes(cabinType);
export const isLockItInCabin = (cabinType = '') => LOCK_IT_IN_CABIN_TYPES.includes(cabinType);
